import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import _ from 'lodash'
import React from 'react'
import { renderDefaultColumn } from './renderColumnFunctions'

dayjs.extend(isSameOrBefore)

/**
@description Generates title for the week column.

@param {array} week. The week to be converted. A collection
of days.

@returns {string} Week title.
E.g. 1-7 July 2020 -> July 2020
E.g. 1-3 July 2020 -> *blank*
E.g. 28 Jun-3 July 2020 -> Jun/Jul 2020
*/

export const generateWeekTitle = (week) => {
  if (week.length < 4) return null

  const firstDay = dayjs(week[0].key, 'DD-MM-YYYY')
  const lastDay = dayjs(_.last(week).key, 'DD-MM-YYYY')
  const firstDayMonth = firstDay.format('MMM')
  const lastDayMonth = lastDay.format('MMM')

  if (firstDayMonth !== lastDayMonth) {
    return `${firstDayMonth}/${lastDayMonth} ${lastDay.format('YYYY')}`
  }

  return `${lastDay.format('MMMM YYYY')}`
}

/**
@description Gets dates for the table.

@param {string} startDate. The start date. E.g. 12-12-2020

@param {string} endDate. The end date.

@returns {array} A collection of date objects.
*/

export const getDates = (startDate, endDate, isPDF) => {
  const dates = []

  const chartStartDate = dayjs(startDate, 'DD-MM-YYYY')
  const chartEndDate = dayjs(endDate, 'DD-MM-YYYY')

  for (
    let indexDate = chartStartDate;
    indexDate.isSameOrBefore(chartEndDate);
    indexDate = indexDate.add(1, 'day')
  ) {
    if (dayjs().isSame(indexDate, 'day') && !isPDF) {
      dates.push({
        className: 'today',
        key: indexDate.format('DD-MM-YYYY'),
        dataIndex: indexDate.format('DD-MM-YYYY'),
        title: <div style={styles.dateToday}> {indexDate.format('D')} </div>,
        width: 60,
        render: renderDefaultColumn
      })
    } else {
      dates.push({
        key: indexDate.format('DD-MM-YYYY'),
        dataIndex: indexDate.format('DD-MM-YYYY'),
        title: indexDate.format('D'),
        width: 60,
        render: renderDefaultColumn,
        textWrap: 'word-break',
        ellipsis: true
      })
    }
  }

  return dates
}

/**
@description Splits dates into collections of weeks

@param {array} dates. The dates to be split.

@returns {array} A collection of week objects.
*/

export const splitDatesIntoWeeks = (dates) => {
  const firstWeek = [
    _.takeWhile(dates, (date) => {
      const dayOfWeek = dayjs(date.key, 'DD-MM-YYYY').format('ddd')
      return dayOfWeek !== 'Mon'
    })
  ]

  const otherWeeks = _.chunk(_.drop(dates, firstWeek[0].length), 7)

  const weeks = firstWeek[0].length
    ? _.concat(firstWeek, otherWeeks)
    : otherWeeks

  return weeks
}

const styles = {
  dateToday: {
    background: colors.informationblue,
    borderRadius: 24,
    color: colors.white,
    height: 24,
    paddingLeft: 1,
    paddingTop: 1,
    width: 24
  }
}
